'use client';

import React from 'react';
import Header from '@/components/Header';
import Hero from '@/components/Hero';
import AboutSection from '@/components/AboutSection';
import ShopByCategorySection from '@/components/ShopByCategorySection';
import FeaturedProducts from '@/components/FeaturedProducts';
import DualPromoBanner from '@/components/DualPromoBanner';
import OccasionsSection from '@/components/OccasionsSection';
import TraditionSpotlightSection from '@/components/TraditionSpotlightSection';
import FestivalCollections from '@/components/FestivalCollections';
import CorporateAndBulkSection from '@/components/CorporateAndBulkSection';
import TrustAndNewsletterSection from '@/components/TrustAndNewsletterSection';
import FinalCTA from '@/components/FinalCTA';
import Footer from '@/components/Footer';

import AdminPortal from '@/components/AdminPortal';
import { useCommerce } from '@/context/CommerceContext';

export default function Home() {
  const { activeView } = useCommerce();

  if (activeView === 'admin') {
    return (
      <main>
        <AdminPortal />
      </main>
    );
  }

  return (
    <main className="min-h-screen flex flex-col bg-[#1C2E23]">
      {/* Global Navigation Header with Center Logo & Mega Menu */}
      <Header />

      {/* 1. Hero Banner */}
      <Hero />
<FeaturedProducts />
      {/* 1b. About / Why Elavarasi Foods Section with Center Toon Mascot */}
      <AboutSection />

      {/* 2. Shop by Category: Main product categories */}
      <ShopByCategorySection />

      {/* 3. Featured Products: Best sellers / popular products */}
      

      {/* 4. Promotional Banner 1: Weekend Super Saver & Express Delivery */}
      <DualPromoBanner />

      {/* 5. Shop by Occasion: Wedding, Birthday, Housewarming, Return Gifts, Events */}
      <OccasionsSection />

      {/* 5b. Half & Half Heritage Spotlight: 2x2 Product Grid on Left, Visual Feature on Right */}
      <TraditionSpotlightSection />

      {/* 6. Festival Collections: Current/upcoming festivals, Festival packages */}
      <FestivalCollections />

      {/* 7. Corporate & Bulk Orders: Corporate gifting, Bulk orders, Request Quote */}
      <CorporateAndBulkSection />

      {/* 8. Testimonials: Customer reviews & VIP community */}
      <TrustAndNewsletterSection />

      {/* 12. Final CTA: Shop, Bulk Order, Corporate, Contact */}
      <FinalCTA />

      {/* Global Brand Footer */}
      <Footer />
    </main>
  );
}
